export type NodeType =
	| "greeting"
	| "question"
	| "ai-response"
	| "condition"
	| "lead-capture"
	| "qualify"
	| "handoff"
	| "end";

export interface FlowNode {
	id: string;
	type: NodeType;
	label: string;
	x: number;
	y: number;
	config: NodeConfig;
}

export interface NodeConfig {
	message?: string;
	prompt?: string;
	field?: string;
	condition?: string;
	trueLabel?: string;
	falseLabel?: string;
	qualifyScore?: number;
	handoffEmail?: string;
}

export interface FlowConnection {
	id: string;
	from: string;
	to: string;
	label?: string;
}

export interface ChatMessage {
	id: string;
	role: "user" | "bot" | "system";
	content: string;
	timestamp: Date;
	nodeId?: string;
}

export interface Lead {
	id: string;
	name: string;
	email: string;
	score: number;
	status: "new" | "qualified" | "contacted" | "converted" | "lost";
	messages: ChatMessage[];
	capturedAt: Date;
	tags: string[];
}

export const NODE_COLORS: Record<NodeType, string> = {
	greeting: "#10b981",
	question: "#6366f1",
	"ai-response": "#8b5cf6",
	condition: "#f59e0b",
	"lead-capture": "#ec4899",
	qualify: "#06b6d4",
	handoff: "#f97316",
	end: "#6b7280",
};

export const NODE_ICONS: Record<NodeType, string> = {
	greeting: "Hand",
	question: "HelpCircle",
	"ai-response": "Sparkles",
	condition: "GitBranch",
	"lead-capture": "UserPlus",
	qualify: "Star",
	handoff: "PhoneForwarded",
	end: "Flag",
};

export const NODE_LABELS: Record<NodeType, string> = {
	greeting: "Greeting",
	question: "Question",
	"ai-response": "AI Response",
	condition: "Condition",
	"lead-capture": "Lead Capture",
	qualify: "Qualify",
	handoff: "Handoff",
	end: "End Chat",
};
